import { render, staticRenderFns } from "./Alimentos.vue?vue&type=template&id=718ad4da&"
import script from "./Alimentos.vue?vue&type=script&lang=js&"
export * from "./Alimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports